import React, {
  useContext,
  useState,
  useEffect,
  forwardRef,
  useMemo,
} from 'react'
import ValuePoint from 'admin/components/ValuePoint'
import { BalanceSheetRow } from 'layouts/authenticated/pages/dashboard/components/BalanceSheet/BalanceSheetRow'

import {
  Card,
  Grid,
  Typography,
  Collapse,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Dialog,
  DialogContent,
  IconButton,
  Grow,
  Box,
  Icon,
} from '@mui/material'
import { motion } from 'framer-motion'
import { Close, ExpandMore } from '@mui/icons-material'
import { BalanceSheetModalForm } from 'layouts/authenticated/pages/dashboard'
import { NewBalanceSheetModalForm } from 'layouts/authenticated/pages/newdash/components/NewBalanceSheetModalForm'
const Transition = forwardRef(function Transition(props, ref) {
  return <Grow timeout={300} ref={ref} {...props} />
})

import { useModal } from 'components/modals'
import AssetsTable from 'atoms/AssetsTable'
import { AccountRow } from 'atoms/AssetsTable'
import { CallToActionRow } from 'atoms/AssetsTable'

function Budgeting({
  collapseSections,
  toggleCollapse,
  incomes,
  expenses,
  getAccounts,
  intakeState,
}) {
  const { openModal } = useModal()
  const [id, setId] = useState()
  const [version, setVersion] = useState()
  const [type, setType] = useState()
  const [name, setName] = useState()
  const [plaidName, setPlaidName] = useState()
  const [subType, setSubType] = useState()
  const [sortKey, setSortKey] = useState()
  const [amount, setAmount] = useState()
  const [subTypeClassification, setSubTypeClassification] = useState()
  const [interestRate, setInterestRate] = useState()
  const [monthlyPayment, setMonthlyPayment] = useState()
  const [frequency, setFrequency] = useState()
  const [ieStartDate, setIeStartDate] = useState()
  const [policyNumber, setPolicyNumber] = useState()
  const [balance, setBalance] = useState()
  const [loanEndDate, setLoanEndDate] = useState()
  const [modalTitle, setModalTitle] = useState()
  const [open, setOpen] = useState(false)
  const [canEdit, setCanEdit] = useState(false)
  const dateOfBirth = intakeState?.dateOfBirth || new Date()
  const handleSubmit = () => {
    handleClose()
  }

  // console.log(expenses)

  const handleClose = () => {
    setOpen(false)
    setCanEdit(false)
    setVersion('')
    setId('')
    setType('')
    setName('')
    setPlaidName('')
    setSubType('')
    setAmount('')
    setSortKey('')
    setModalTitle('')
    setSubTypeClassification('')
    setInterestRate('')
    setLoanEndDate('')
    setMonthlyPayment('')
    setFrequency('')
    setIeStartDate('')
    setPolicyNumber('')
    setBalance('')
  }

  const handleIncomeClickOpen = () => {
    setOpen(true)
    setSubType('')
    setType('income')
    setModalTitle('Add an Income Stream')
  }

  const handleExpenseClickOpen = () => {
    setOpen(true)
    setSubType('')
    setType('expense')
    setModalTitle('Add an Expense')
  }

  const handleViewIncome = ({
    id,
    typeSubTypeUuid,
    _version,
    name,
    plaidName,
    amount,
    subType,
    subTypeClassification,
    interestRate,
    loanEndDate,
    monthlyPayment,
    frequency,
    ieStartDate,
    balance,
    policyNumber,
  }) => {
    setType('income')
    setId(id)
    setVersion(_version)
    setSortKey(typeSubTypeUuid)
    setName(name)
    setPlaidName(plaidName)
    setSubType(subType)
    setAmount(amount)
    setOpen(true)
    setCanEdit(true)
    setModalTitle(`Update ${name}`)
    setSubTypeClassification(subTypeClassification)
    setInterestRate(interestRate)
    setLoanEndDate(loanEndDate)
    setMonthlyPayment(monthlyPayment)
    setFrequency(frequency)
    setIeStartDate(ieStartDate)
    setPolicyNumber(policyNumber)
    setBalance(balance)
  }
  const handleViewExpense = ({
    id,
    typeSubTypeUuid,
    _version,
    name,
    plaidName,
    amount,
    subType,
    subTypeClassification,
    interestRate,
    loanEndDate,
    monthlyPayment,
    frequency,
    ieStartDate,
    balance,
  }) => {
    setType('expense')
    setId(id)
    setVersion(_version)
    setSortKey(typeSubTypeUuid)
    setName(name)
    setPlaidName(plaidName)
    setSubType(subType)
    setAmount(amount)
    setOpen(true)
    setCanEdit(true)
    setModalTitle(`Update ${name}`)
    setSubTypeClassification(subTypeClassification)
    setInterestRate(interestRate)
    setLoanEndDate(loanEndDate)
    setMonthlyPayment(monthlyPayment)
    setFrequency(frequency)
    setIeStartDate(ieStartDate)
    setBalance(balance)
  }
  const handleReload = () => {
    getAccounts()
  }
  const incomeSum = (incomes || [])
    .map((incomes) =>
      incomes.frequency === 'monthly'
        ? incomes.type === 'assetIncome'
          ? incomes.monthlyPayment || 0
          : incomes.amount
        : (incomes.type === 'assetIncome'
            ? incomes.monthlyPayment || 0
            : incomes.amount) / 12
    )
    .reduce((a, b) => a + b, 0)
  const expenseSum = (expenses || [])
    .map((expenses) =>
      expenses.frequency === 'monthly'
        ? expenses.type === 'liability'
          ? expenses.monthlyPayment || 0
          : expenses.amount
        : (expenses.type === 'liability'
            ? (expenses.monthlyPayment || 0) * 12
            : expenses.amount) / 12
    )
    .reduce((a, b) => a + b, 0)
  const rows = useMemo(() => {
    const safeIncomes = incomes || []
    const safeExpenses = expenses || []

    // console.log('safeIncomes', safeIncomes)

    return [
      {
        header: 'Additional Income Streams',
        headerValue: incomeSum,
        expandable: true,
        addAccountRow: 'Income',
        content: (
          <>
            {safeIncomes.map((income, index) => (
              <AccountRow
                onClick={() => {
                  openModal('editAccount', {
                    accountType: 'Income',
                    account: income,
                    getAccounts: getAccounts,
                  })
                }}
                key={index}
                name={income.name || 'Unnamed Account'}
                amount={
                  (income.frequency === 'monthly'
                    ? income.type === 'assetIncome'
                      ? income.monthlyPayment || 0
                      : income.amount
                    : (income.type === 'assetIncome'
                        ? income.monthlyPayment || 0
                        : income.amount) / 12) || 0
                }
                img={income.externalInstitutionLogo}
                subType={income.subType}
                linked={income?.externalAsset}
              />
            ))}
          </>
        ),
      },

      {
        header: 'Additional Expenses',
        headerValue: expenseSum,
        expandable: true,
        addAccountRow: 'Expense',

        content: (
          <>
            {safeExpenses.map((expense, index) => (
              <AccountRow
                onClick={() => {
                  openModal('editAccount', {
                    accountType: 'Expense',
                    account: expense,
                    getAccounts: getAccounts,
                  })
                }}
                key={index}
                name={expense.name || 'Unnamed Account'}
                amount={
                  (expense.frequency === 'monthly'
                    ? expense.type === 'liability'
                      ? expense.monthlyPayment || 0
                      : expense.amount
                    : (expense.type === 'liability'
                        ? (expense.monthlyPayment || 0) * 12
                        : expense.amount) / 12) || 0
                }
                img={expense.externalInstitutionLogo}
                subType={expense.subType}
                linked={expense?.externalAsset}
              />
            ))}
          </>
        ),
      },
    ]
  }, [incomes, expenses, intakeState])
  return (
    <>
      {/* <BalanceSheetModalForm
        handleClose={handleClose}
        type={type}
        name={name}
        amount={amount}
        version={version}
        id={id}
        subType={subType}
        setVersion={setVersion}
        setId={setId}
        setType={setType}
        setSubType={setSubType}
        setSubTypeClassification={setSubTypeClassification}
        subTypeClassification={subTypeClassification}
        interestRate={interestRate}
        setInterestRate={setInterestRate}
        monthlyPayment={monthlyPayment}
        setMonthlyPayment={setMonthlyPayment}
        loanEndDate={loanEndDate}
        setLoanEndDate={setLoanEndDate}
        frequency={frequency}
        setFrequency={setFrequency}
        setName={setName}
        plaidName={plaidName}
        setAmount={setAmount}
        typeSubTypeUuid={sortKey}
        key={sortKey}
        open={open}
        handleSubmit={handleSubmit}
        reloadAccounts={getAccounts}
        modalHeader={modalTitle}
      /> */}
      {/* <Dialog
        open={open}
        onClose={handleClose}
        TransitionComponent={Transition}
        fullWidth
        maxWidth={'sm'}
        PaperProps={{
          sx: {
            overflow: { xs: 'auto', sm: 'visible' },
            margin: '16px',
            width: 'calc(100% - 32px)',
          },
        }}
      >
        <Box
          sx={{
            justifyContent: 'space-between',
            position: 'relative',
            display: 'flex',
            top: { xs: 8, sm: -48 },
          }}
        >
          <IconButton
            onClick={handleClose}
            sx={{
              position: 'absolute',
              top: 0,
              right: { xs: 8, sm: 0 },
              color: '#fff',
              zIndex: 1,
              backgroundColor: '#000',
              '&:hover': {
                backgroundColor: '#000',
              },
            }}
          >
            <Close />
          </IconButton>
        </Box>
        <Box sx={{ overflow: { xs: 'auto', sm: 'hidden' } }}>
          <DialogContent
            sx={{ overflow: 'visible', paddingTop: { xs: '40px', sm: '16px' } }}
          >
            <motion.div
              key="accounts"
              initial={{ opacity: 0, scale: 0.95 }}
              animate={{ opacity: 1, scale: 1 }}
              exit={{ opacity: 0, scale: 0.95 }}
              transition={{ duration: 0.3, ease: 'easeInOut' }}
            >
              <Box sx={{ marginBottom: '16px' }}>
                <Typography variant={'headerTitle'} color={'#262627'}>
                  {modalTitle}
                </Typography>
              </Box>
              <NewBalanceSheetModalForm
                handleClose={handleClose}
                canEdit={canEdit}
                type={type}
                name={name}
                amount={amount}
                version={version}
                id={id}
                subType={subType}
                setVersion={setVersion}
                setId={setId}
                setType={setType}
                setSubType={setSubType}
                setSubTypeClassification={setSubTypeClassification}
                subTypeClassification={subTypeClassification}
                interestRate={interestRate}
                setInterestRate={setInterestRate}
                monthlyPayment={monthlyPayment}
                setMonthlyPayment={setMonthlyPayment}
                frequency={frequency}
                setFrequency={setFrequency}
                ieStartDate={ieStartDate}
                setIeStartDate={setIeStartDate}
                setPolicyNumber={setPolicyNumber}
                policyNumber={policyNumber}
                setBalance={setBalance}
                balance={balance}
                loanEndDate={loanEndDate}
                setLoanEndDate={setLoanEndDate}
                setName={setName}
                plaidName={plaidName}
                setAmount={setAmount}
                typeSubTypeUuid={sortKey}
                key={sortKey}
                open={true}
                handleSubmit={handleClose}
                reloadAccounts={handleReload}
                newStyle={true}
                dateOfBirth={dateOfBirth}
                // handleClose={onClose}
              />
            </motion.div>
          </DialogContent>
        </Box>
      </Dialog> */}
      <Grid item xs={12} md={4} xl={3}>
        <Card
          sx={{
            overflow: 'visible',
            textAlign: 'left',
            boxShadow: '0px 4px 25px -8px rgba(0,0,0,0.2)',
            backgroundColor: '#f8f9fa',
            borderRadius: 2,
            p: 2,
          }}
        >
          <Grid container columnSpacing={3} rowSpacing={2}>
            <Grid item xs={12}>
              <Typography variant="valueTitle">VALUE POINTS</Typography>
              <Collapse
                in={collapseSections.budgeting}
                style={{ width: '100%' }}
              ></Collapse>
            </Grid>
          </Grid>
        </Card>
      </Grid>
      <Grid item xs={12} md={8} xl={9}>
        <Card
          id="budgeting"
          sx={{
            overflow: 'visible',
            textAlign: 'left',
            boxShadow: '0px 4px 25px -8px rgba(0,0,0,0.2)',
            borderRadius: 2,
            p: 2,
            pb: 0,
          }}
        >
          <Grid container columnSpacing={3} rowSpacing={2} pb={2}>
            <Grid
              item
              xs={12}
              onClick={() => toggleCollapse('budgeting')}
              sx={{
                cursor: 'pointer',
                display: 'flex',
                alignItems: 'center',
              }}
            >
              <Typography variant="h4" sx={{ flexGrow: 1 }}>
                Budgeting
              </Typography>
              <ExpandMore
                sx={{
                  height: '1.5em',
                  width: '1.5em',
                  transform: collapseSections.budgeting
                    ? 'rotate(180deg)'
                    : 'rotate(0deg)',
                  transition: 'transform 0.3s ease-in-out',
                }}
              />
            </Grid>
          </Grid>
          <Collapse in={collapseSections.budgeting} style={{ width: '100%' }}>
            <Grid container columnSpacing={3} rowSpacing={2} py={2}>
              <Grid item xs={12} md={8}>
                <AssetsTable
                  getAccounts={getAccounts}
                  rows={rows}
                  color={'blue'}
                />
              </Grid>
              {/* <Grid item xs={12} md={8}>
                <BalanceSheetRow
                  accounts={incomes}
                  handleAddAccount={handleIncomeClickOpen}
                  category={'AllIncomes'}
                  handleViewAccount={handleViewIncome}
                  accountType="Additional Income Streams"
                  addAccountButtonText="Add an Income Stream"
                />
              </Grid>
              <Grid item xs={12} md={8}>
                <BalanceSheetRow
                  accounts={expenses}
                  handleAddAccount={handleExpenseClickOpen}
                  category={'AllExpenses'}
                  handleViewAccount={handleViewExpense}
                  accountType="Additional Expenses"
                  addAccountButtonText="Add an Expense"
                />
              </Grid> */}
            </Grid>
          </Collapse>
        </Card>
      </Grid>
    </>
  )
}

export default Budgeting
